import { useState, useEffect, useCallback } from 'react';
import safeStorage from '../utils/safeStorage';

/** Sync JWT read — first paint must not wait on useEffect (Enter Club + cached club). */
export function readCurrentUserFromToken(token = safeStorage.getItem('token')) {
  try {
    if (!token) return null;

    const [, payloadBase64] = token.split('.');
    if (!payloadBase64) return null;
    const normalized = payloadBase64.replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(atob(normalized));

    return {
      id: payload.user_id,
      username: payload.username || '',
      first_name: payload.first_name || '',
      last_name: payload.last_name || '',
      email: payload.email || '',
    };
  } catch (error) {
    console.error('Error parsing JWT token:', error);
    return null;
  }
}

export function useCurrentUser() {
  const [currentUser, setCurrentUser] = useState(() => readCurrentUserFromToken());
  const [loading, setLoading] = useState(false);

  const getCurrentUserFromToken = useCallback(() => readCurrentUserFromToken(), []);

  const getDisplayName = useCallback((user) => {
    if (!user) return 'Unknown User';

    if (user.first_name && user.last_name) {
      return `${user.first_name} ${user.last_name}`;
    }

    if (user.first_name) {
      return user.first_name;
    }

    if (user.username) {
      return user.username;
    }

    return 'Unknown User';
  }, []);

  useEffect(() => {
    setCurrentUser(readCurrentUserFromToken());
    setLoading(false);
  }, []);

  return {
    currentUser,
    loading,
    getDisplayName,
    getCurrentUserFromToken,
  };
}
